import styled from 'styled-components';

export const LoadMore = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const ScrollArea = styled.div`
  max-height: min(640px, 70vh);
  overflow-y: auto;
  overflow-anchor: none;
`;

export const Row = styled.div`
  display: flow-root;
`;

// Goes through `style` so scrolling doesn't mint a new class per offset.
export const Spacer = styled.div.attrs<{ $top: number; $bottom: number }>(({ $top, $bottom }) => ({
  style: { paddingTop: $top, paddingBottom: $bottom },
}))``;
